import React, { useCallback, useEffect, useState } from "react";
import { IVideo } from "../hooks/useFetchVideos";
import { IFile, fetchThumbnails } from "./helpers";
import { ThumbnailsList } from "./ThumbnailsList";
import type { PanelStatus } from "./panels";

interface Props {
  /** The video's project: its brands' pre-approval setting gates "All". */
  project?: any;
  video: IVideo;
  onCount?: (n: number) => void;
}

export function ThumbnailsPanel({ video, project, onCount }: Props) {
  const [thumbnails, setThumbnails] = useState<Array<IFile>>([]);
  // The list is discovered by probing S3 URLs, which takes seconds. Without a
  // real loading status the panel rendered its EMPTY state for the duration and
  // then silently populated.
  const [status, setStatus] = useState<PanelStatus>("loading");
  const [attempt, setAttempt] = useState(0);

  const retry = useCallback(() => setAttempt((n) => n + 1), []);

  useEffect(() => {
    if (!video) return undefined;
    let live = true;
    setStatus("loading");
    fetchThumbnails(video)
      .then((found) => {
        if (!live) return;
        const all = found;
        setThumbnails(all);
        onCount?.(all.length);
        setStatus("ready");
      })
      .catch(() => {
        if (!live) return;
        setThumbnails([]);
        setStatus("error");
      });
    return () => {
      live = false;
    };
  }, [video, attempt]);

  return (
    <ThumbnailsList
      project={project}
      video={video}
      thumbnails={thumbnails}
      videoName={video?.name}
      bucket={video?.bucket}
      status={status}
      onRetry={retry}
    />
  );
}
